var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AlertDismiss',{ref:"alertDismiss",staticClass:"mx-2"}),(_vm.load)?_c('LoadCard'):_c('DashboardCard',[_c('blockquote',{staticClass:"card-blockquote"},[_c('b-icon',{staticClass:"icone-statements",attrs:{"icon":"mailbox"}}),_c('p',[_vm._v("Denuncias subidas")]),_c('footer',[_c('h2',[_vm._v(_vm._s(_vm.getCount))])])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }